import { toastr } from 'react-redux-toastr';
import { getToastContent } from './getToastContent';
import errorMessage from './errorMessages_en';

const showToaster = ({ messageId, requestContent, lang, toasterType }) => {
    let result, language, title;
    language = lang ? lang : 'en';
    if (language = 'en') {
        title = errorMessage(toasterType);
        result = errorMessage(messageId, requestContent);
    }
    return toastr[toasterType](title, result);
}

export { showToaster };
